module.exports = __webpack_public_path__ + "static/media/page_not_found_dark.87119b13.svg";